import * as React from "react";
import { Formik } from "formik";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useState } from "react";
import axios from "axios";
import {
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Paper,
  Table,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

// @mui
import {
  IconButton,
  Card,
  Stack,
  Container,
  Typography,
  Breadcrumbs,
  Box,
  TextField,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
// hooks
import useSettings from "src/hooks/useSettings";
import useDetails from "../../../hooks/useDetails";

// components
import Page from "src/components/Page";

// ----------------------------------------------------------------------
export default function CompletedForms() {
  const { themeStretch } = useSettings();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();

  const userDetails = useDetails();
  let p_id = userDetails?.pp_id;
  //   //console.log(p_id );

  const handleFormSubmit = (values) => {
    // //console.log(values);
  };
  const handleView = (patient_id, submit_date, name) => {
    if (name == "Headache Impact Test") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/hit", {
        state: { patient_id, submit_date },
      });
      //   //console.log("HIT")
    } else if (name == "Epworth Sleepiness Scale") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/ess", {
        state: { patient_id, submit_date },
      });
      //   //console.log("ESS")
    } else if (name == "Convergence Insufficiency Symptom Survey") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/ciss", {
        state: { patient_id, submit_date },
      });
      //   //console.log("CISS")
    } else if (name == "BDI") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/bdi", {
        state: { patient_id, submit_date },
      });
      //   //console.log("BDI")
    } else if (name == "Neuropsychiatric Patient Questionnaire") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/npi", {
        state: { patient_id, submit_date },
      });
      //   //console.log("NPI Q")
    }
    // Rivermead Post-Concussion Symptoms'
    else if (name == "Rivermead Post-Concussion Symptoms'") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/rpcs", {
        state: { patient_id, submit_date },
      });
      //   //console.log("RPCS")
    } else if (name == "Patient Health Questionnaire") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/phq", {
        state: { patient_id, submit_date },
      });
      //   //console.log("PHQ")
    }
    // Quality of Life
    else if (name == "Quality of Life") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/qol", {
        state: { patient_id, submit_date },
      });
      //console.log("QoL")
    }
    // GAD-7
    else if (name == "GAD-7") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/gad", {
        state: { patient_id, submit_date },
      });
      //console.log("GAD")
    }
    // LAwton
    else if (name == "Lawton") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/lawton", {
        state: { patient_id, submit_date },
      });
      //console.log("Lawton")
    }
    // Katz
    else if (name == "Katz") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/katz", {
        state: { patient_id, submit_date },
      });
      //console.log("Katz")
    }
    // ADHD
    else if (name == "ADHD") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/adhd", {
        state: { patient_id, submit_date },
      });
      //console.log("ADHD")
    } else if (name == "Coaching Agreement and Informed Consent") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/caic", {
        state: { patient_id, submit_date },
      });
      //console.log("CAIC")
    } else if (
      name ==
      "Informed Consent for Psychotherapy & Cognitive Rehabilitation Therapy"
    ) {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/cpcr", {
        state: { patient_id, submit_date },
      });
      //console.log("CPCR")
    } else if (name == "Informed Consent for Neuropsychological Assessment") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/icna", {
        state: { patient_id, submit_date },
      });
      //console.log("ICNA")
    }
    //Medication Checklist
    else if (name == "Medication Checklist") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/medical", {
        state: { patient_id, submit_date },
      });
      //console.log("Medical")
    }
    //
    else if (name == "Mini Nutritional Assessment ") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/mna", {
        state: { patient_id, submit_date },
      });
      //console.log("MNA")
    } else if (name == "Modified Baecke") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/mb", {
        state: { patient_id, submit_date },
      });
      //console.log("MB")
    }
    //HIPAA Release Form
    else if (name == "HIPAA Release Form") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/hipaarf", {
        state: { patient_id, submit_date },
      });
      //console.log("MB")
    }
    //New Patient Headache Questionnaire
    else if (name == "New Patient Headache Questionnaire") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/nphq", {
        state: { patient_id, submit_date },
      });
      //console.log("NPHQ")
    }
    //Facial Pain Questionnaire
    else if (name == "Facial Pain Questionnaire") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/fpq", {
        state: { patient_id, submit_date },
      });
      //console.log("FPQ")
    }
    //Sunshine
    else if (name == "Sunshine") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/sunshineact", {
        state: { patient_id, submit_date },
      });
      //console.log("Sunshine")
    }
    //ODQ
    else if (name == "Oxford Depression Questionnaire") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/odq", {
        state: { patient_id, submit_date },
      });
      //console.log("ODQ")
    }
    //FAQ
    else if (
      name ==
      "Functional Activities Questionnaire in Older Adults with Dementia"
    ) {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/faq", {
        state: { patient_id, submit_date },
      });
      //console.log("FAQ")
    }
    //Safety
    else if (name == "Safety Assessment") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/safety", {
        state: { patient_id, submit_date },
      });
      //console.log("SAC")
    }
    //DSRS
    else if (name == "Dementia Severity Rating Scale") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/dsrs", {
        state: { patient_id, submit_date },
      });
      //console.log("DSRS")
    }
    //Stress Thermometer
    else if (name == "My Stress Thermometer") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/stress", {
        state: { patient_id, submit_date },
      });
      //console.log("Stress Thermometer")
    }
    //HIPAA NPP
    else if (name == "HIPAA Notice of Privacy Practices") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/hipaanpp", {
        state: { patient_id, submit_date },
      });
      //console.log("HIPAA NPP")
    }
    // Patient Health Questionnaire-TRM
    else if (name == "Patient Health Questionnaire-TRM") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/phqtrm", {
        state: { patient_id, submit_date },
      });
      //console.log("PHQ")
    }
    // GAD-7 TRM
    else if (name == "GAD 7-TRM") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/gadtrm", {
        state: { patient_id, submit_date },
      });
      //console.log("GAD")
    }
    // RPCS TRM
    else if (name == "Rivermead Post-Concussion Symptoms-TRM") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/rpcstrm", {
        state: { patient_id, submit_date },
      });
      //console.log("RPCS")
    }
    // HIT TRM
    else if (name == "Headache Impact Test-TRM") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/hittrm", {
        state: { patient_id, submit_date },
      });
      //console.log("HIT")
    }
    // ESS TRM
    else if (name == "Epworth Sleepiness Scale-TRM") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/esstrm", {
        state: { patient_id, submit_date },
      });
      //console.log("ESS")
    }
    // CISS TRM
    else if (name == "Convergence Insufficiency Symptom Survey-TRM") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/cisstrm", {
        state: { patient_id, submit_date },
      });
      //console.log("CISS")
    }
    // Patient Health Questionnaire-8
    else if (name == "Patient Health Questionnaire-8") {
      navigate("/dashboard/patientmonitoring/tmpquestionnaires/phq8", {
        state: { patient_id, submit_date },
      });
      //console.log("PHQ-8")
    } else {
      //console.log("NAHH")
    }
    // navigate("/dashboard/patientmonitoring/tmpquestionnaires/hit", { state: { patient_id, submit_date } });
  };

  // const ActionBtn = (id) => {
  const ActionBtn = (patient_id, submit_date, name) => {
    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        <IconButton
          aria-label="add"
          size="medium"
          onClick={() => handleView(patient_id, submit_date, name)}
        >
          <VisibilityIcon fontSize="inherit" />
        </IconButton>
      </Stack>
    );
  };

  const [dep, setDep] = useState("");
  const [users, setUsers] = useState([]);
  React.useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_KAIZEN_API}/api/dev2/tmphistorypatients`)
      .then((res) => {
        setUsers(res.data);
      })
      .catch((error) => {
        //console.log("Error")
      });
  }, []);

  const [pemail, setPemail] = useState("");
  const [rows, setRows] = useState([]);
  // const handletext=(e)=>{
  React.useEffect(() => {
    axios
      .post(
        `${process.env.REACT_APP_KAIZEN_API}/api/dev2/fetchpdata`,
        JSON.stringify({ id: p_id })
      )
      .then((response) => {
        setDep(response.data[0].pname);
        setPemail(response.data[0].email);
      })
      .catch((err) => {
        //console.log(err);
      });

    axios
      .post(
        `${process.env.REACT_APP_KAIZEN_API}/api/dev2/fetchpscore`,
        JSON.stringify({ id: p_id })
      )
      .then((resp) => {
        setRows(resp.data);
      })
      .catch((err) => {
        //console.log(err);
      });
  }, [p_id]);
  // }

  return (
    <>
      <Helmet>
        <title> Patient Monitoring| Kaizen Digital </title>
      </Helmet>
      <Page title="Page Two">
        <Container maxWidth={themeStretch ? false : "xl"}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Stack direction="column" spacing={0}>
              <Typography variant="h3" gutterBottom color="primary">
                Completed Forms
              </Typography>
              <div role="presentation">
                {/* <Breadcrumbs aria-label="breadcrumb">
        <Typography 
        sx={{ display: 'flex', alignItems: 'center' }}
        color="text.primary">
          Dashboard
        </Typography>

        <Typography
          sx={{ display: 'flex', alignItems: 'center' }}
          color="text.primary"
        >
          Patient Monitoring
        </Typography>
        <Typography
          sx={{ display: 'flex', alignItems: 'center' }}
          color="text.primary"
        >
Completed Forms
        </Typography>
      </Breadcrumbs> */}
              </div>
            </Stack>
          </Stack>
          <Card>
            <Box m="20px">
              <Formik onSubmit={handleFormSubmit}>
                {({ handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <Box>
                      <Box
                        display="grid"
                        gap="30px"
                        gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                        sx={{
                          "& > div": {
                            gridColumn: isNonMobile ? undefined : "span 4",
                          },
                        }}
                      >
                        {/* <select 
                         onChange={e => handletext(e)}
                        style={{borderRadius:"5px", borderColor:"#CDCDCD", color:"#5A5A5A"}}
                        >
                          {
                            users.map((user)=>(
                            <option key={user.id} value={user.id}>
                              {user.pname}
                            </option>
                            )
                            )
                          }
                      </select>

                 <TextField
                 label="Email Address"
                 value={pemail}
                sx={{gridColumn:'span 2'}}
                 /> */}
                      </Box>
                    </Box>
                    <br />
                    <Card>
                      <Box sx={{ width: "100%" }}>
                        <TableContainer component={Paper}>
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell align="left">ID</TableCell>
                                <TableCell align="left">FORM NAME</TableCell>
                                <TableCell align="left">SCORE</TableCell>
                                <TableCell align="left">PROVIDER</TableCell>
                                <TableCell align="left">ASSIGNED ON</TableCell>
                                <TableCell align="left">SUBMITTED ON</TableCell>
                                <TableCell align="left">ACTION</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {rows.map((row) => (
                                <TableRow
                                  //  key={row.id}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="left"
                                  >
                                    {row.id}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="left"
                                  >
                                    {row.tmp_name}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="left"
                                  >
                                    {row.score}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="left"
                                  >
                                    {row.dname}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="left"
                                  >
                                    {row.date_of_joining}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="left"
                                  >
                                    {row.date}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="left"
                                  >
                                    {ActionBtn(row.id, row.date, row.tmp_name)}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </Card>
                  </form>
                )}
              </Formik>
            </Box>
          </Card>
        </Container>
      </Page>
    </>
  );
}
